interface LoadingStateProps {
  message?: string;
}

const LoadingState = ({ message = 'Loading dashboard…' }: LoadingStateProps) => (
  <div className="status full-screen">
    <div className="spinner" aria-hidden="true" />
    <p>{message}</p>
  </div>
);

export default LoadingState;
